import { OrderDrawerEntryParams } from 'components/LightConversation/types';
import { noop } from 'lodash-es';
import { createContext, useContext } from 'react';

interface OrderCardContextValue {
  openOrderDrawer: (entryType: OrderDrawerEntryParams) => void;
}

const OrderCardContext = createContext<OrderCardContextValue>({
  openOrderDrawer: noop,
});

export const useOrderCard = () => {
  return useContext(OrderCardContext);
};

export const OrderCardProvider = OrderCardContext.Provider;
